import React from 'react'

const PriceBadge = ({price}) => {
  return (
    <>
    <div className='flex bg-light-secondary rounded-none text-white font-extrabold h-[28px] leading-24  px-15 absolute right-0 text-center shadow-none top-12 whitespace-nowrap w-[80px] mt-6'>
        <span className='ml-3 py-2 mr-1 mb-3 text-sm'>RS</span>
      <div className='pb-1'>270</div>
    </div>
      </>
  )
}

export default PriceBadge
